;(async () => {
  const { default: moment } = await import('moment')
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  import('../../plugins/swiper/swiper.scss')

  Promise.all([import(/* webpackMode: "eager" */ './offers-block-latest.scss')]).then(() => {
    $('.widget.offers-block-latest').each(function (i, el) {
      $(el).data('widget', new OffersBlockLatest(el, Swiper, moment))
      $(el).data('widget').init()
    })
  })
})()

function OffersBlockLatest(el, Swiper, moment) {
  const self = this
  self.el = $(el)
  self.swiperEl = self.el.find('.swiper')
  self.cardsData = []
  self.cardTemplate = require('./offer-block-latest-card.hbs')

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('OffersBlockLatest init', self)
    }
    self.el.css('opacity', 1)

    // Handle the case where the swiper is inside a tab that is not currently visible
    self.parentTabPanel = self.el.parent('.js-panel')
    if (self.parentTabPanel.length && self.parentTabPanel.attr('aria-hidden') === 'true') {
      window.dbs.globalEvents.subscribe('tab_revealed', onTabRevealed)
    } else {
      // If the parent is not a tab, just initialize the swipers
      self.fetchData()
    }
  }

  function onTabRevealed(payload) {
    if (payload.id === self.parentTabPanel?.attr('id')) {
      self.fetchData()
      // Once initialized, unsubscribe from the event
      window.dbs.globalEvents.unsubscribe('tab_revealed', onTabRevealed)
    }
  }

  self.hideWidget = function () {
    console.warn('No offers to display, hiding widget.', self.el)
    self.el.addClass('!hidden')
    self.el.css('opacity', 0)
  }

  self.showWidget = function () {
    self.el.removeClass('!hidden')
    self.el.css('opacity', 1)
  }

  self.fetchData = function () {
    const endpoint = self.el.attr('data-api-endpoint')
    const method = self.el.attr('data-api-method')
    const gdayCaller = self.el.attr('data-api-gday-caller')

    if (!gdayCaller) {
      console.error('No Gday-Caller header provided for OffersBlockTabbed')
      return
    }

    if (!endpoint && !method) {
      console.error('No API endpoint or method defined for OffersBlockTabbed')
    }

    $.ajax({
      url: endpoint,
      type: method,
      contentType: 'application/json',
      headers: {
        'Gday-Caller': gdayCaller,
      },
    })
      .done(function (res) {
        console.log('fetchData', res)

        // If res has 0 or 1 items, hide this widget
        if (res.length > 1) {
          const filteredData = self.filterData(res)
          const sortedData = self.sortData(filteredData)
          self.formatData(sortedData)
        } else {
          self.hideWidget()
        }
      })
      .fail(function () {
        self.hideWidget()
        console.error('Failed to fetch data for OffersBlockLatest', endpoint, method)
      })
  }

  function parseDataAttribute(attrName, fallback = []) {
    if (!attrName.startsWith('data-')) {
      console.warn(`Invalid attribute: ${attrName}`)
      return fallback
    }

    const raw = self.el.attr(attrName)
    if (!raw || !raw.trim()) return fallback

    try {
      const normalized = raw.replace(/'/g, '"')
      const parsed = JSON.parse(normalized)

      return parsed
    } catch (e) {
      console.warn(`Failed to parse ${attrName}:`, raw)
      return fallback
    }
  }

  self.sortData = function (data) {
    // Sort data by endUtc in ascending order
    return data.sort((a, b) => {
      const dateA = moment(a.endUtc)
      const dateB = moment(b.endUtc)
      return dateA - dateB
    })
  }

  self.filterData = function (data) {
    let filteredData = data

    // Filter by allowed states
    const allowedStates = parseDataAttribute('data-allowed-states')
    if (allowedStates.length > 0) {
      filteredData = filteredData.filter((item) => {
        return allowedStates.includes(item.park.address.state)
      })
    }

    // Filter by allowed parks
    const allowedParks = parseDataAttribute('data-allowed-parks')
    if (allowedParks.length > 0) {
      filteredData = filteredData.filter((item) => {
        console.log('item.parkCode', item.parkCode)
        return allowedParks.includes(item.parkCode)
      })
    }

    // Filter by allowed offers
    const allowedOffers = parseDataAttribute('data-allowed-offers')
    if (allowedOffers.length > 0) {
      filteredData = filteredData.filter((item) => {
        return allowedOffers.includes(item.dealCode)
      })
    }

    // Only offers that are still active
    const nowUtc = moment.utc() // current time in UTC
    filteredData = filteredData.filter((item) => moment(item.endUtc) >= nowUtc)

    return filteredData
  }

  self.formatData = function (data) {
    function createEndsInLabel(endDateUtc) {
      if (!endDateUtc) {
        console.error('No end date provided')
        return ''
      }

      // Determine how many days until the offer ends
      const endUtc = moment(endDateUtc)
      const nowUtc = moment.utc() // current time in UTC
      const diffInDays = endUtc.diff(nowUtc, 'days')

      // Return label based on the number of days remaining
      if (diffInDays === 0) {
        return 'Ends today'
      } else if (diffInDays === 1) {
        return 'Ends in 1 day'
      } else {
        return `Ends in ${diffInDays} days`
      }
    }

    function simplifyConditions(conditionsArr) {
      // get 'description' from each object in the array
      let conditions = conditionsArr.map((c) => {
        return c.description
      })
      // Return only first 4 items
      return conditions.slice(0, 4)
    }

    // Loop through data and get tabs and cards data needed to render the UI
    const displayLimit = self.el.attr('data-display-limit')
    data.map((item) => {
      if (displayLimit && self.cardsData.length >= displayLimit) {
        console.warn(`Latest offers reached its display limit of ${displayLimit}. Not adding more offers.`)
        return
      }

      // Create cards data object
      // Simplify the data to only include the fields we need to render the cards
      self.cardsData.push({
        id: item.id,
        applyUrl: `/deals/${item.parkCode}/${item.dealCode}/apply`,
        removeUrl: `/deals/${item.parkCode}/${item.dealCode}/remove`,
        parkCode: item.parkCode,
        dealCode: item.dealCode,
        imageUrl: item.promotionalContent.imageUrl,
        dealTagLabel: item.description, // HPR-376 do not use 'item.promotionalContent.text'
        suburb: item.park.address.suburb,
        state: item.park.address.state,
        conditions: simplifyConditions(item.eligibility.conditions),
        endUtc: item.endUtc,
        endsInLabel: createEndsInLabel(item.endUtc),
      })
    })

    // Render cards
    self.renderCards(self.cardsData)

    // Initialize the swipers now we have cards in the DOM
    self.initSwiper()
  }

  self.renderCards = function (cardsData) {
    // Clear existing cards
    const cardsContainerEl = self.el.find('.js-cards-container')
    cardsContainerEl.empty()

    // TODO: Check if we have rendered cards already, and just update DOM instead of re-rendering

    // Create cards HTML
    const cardsFragment = new DocumentFragment()
    cardsData.forEach((datum) => {
      const template = document.createElement('template')
      template.innerHTML = self.cardTemplate(datum)
      cardsFragment.append(template.content)
    })

    // Append cards to the DOM
    cardsContainerEl.append(cardsFragment)

    // Update data-slides-count attribute on the swiper element
    self.swiperEl.attr('data-slides-count', cardsData.length)
  }

  self.initSwiper = function () {
    // NOTE: Swiper can have nested sliders, so we need to find the first swiper instance
    const swiperEl = self.el.find('.swiper').first()
    // Find all slides in the swiper
    const slides = swiperEl.find('.swiper-slide')
    swiperEl.attr('data-slides-count', slides.length)
    // Only setup navigation if there are more than 4 slides
    let navigation = {}
    if (slides.length > 3) {
      // Buttons are not within the swiperEl, but within the parent element
      const nextEl = self.el.find('.swiper-button-next')
      const prevEl = self.el.find('.swiper-button-prev')

      navigation = {
        nextEl,
        prevEl,
      }

      // Show the navigation buttons
      nextEl.removeClass('!hidden')
      prevEl.removeClass('!hidden')
    }

    self.swiper = new Swiper(swiperEl, {
      loop: false,
      autoHeight: false,
      watchOverflow: true,
      slidesPerView: 'auto',
      navigation,
      pagination: {
        el: swiperEl.find('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
    })
  }
}
